import { LayoutDashboard, Users, Megaphone, ShieldCheck, BarChart3 } from "lucide-react";

// Public marketing nav (root-level public routes; /app authenticated stays separate).
export const PUBLIC_NAV = [
  { label: "Platform", to: "/platform" },
  { label: "See It in Action", to: "/demo" },
  { label: "Features", to: "/features" },
  { label: "RESA", to: "/resa" },
  { label: "Pricing", to: "/pricing" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "Resources", to: "/resources" },
  { label: "About", to: "/about" },
];

export const PILLARS = [
  {
    key: "run", label: "RUN", icon: LayoutDashboard,
    tagline: "Run the day-to-day business.",
    items: ["Dashboard", "Calendar", "Tasks", "Documents", "Notifications"],
  },
  {
    key: "sell", label: "SELL", icon: Users,
    tagline: "Manage relationships and revenue activity.",
    items: ["CRM", "Leads", "Pipeline", "Smart Follow-Up", "Transactions", "Commissions"],
  },
  {
    key: "market", label: "MARKET", icon: Megaphone,
    tagline: "Build and manage your presence.",
    items: ["Marketing Center", "AI Content", "Content Calendar", "Brand Profile"],
    note: "Content is created and planned inside AgentHQ. Direct social publishing is not included.",
  },
  {
    key: "protect", label: "PROTECT", icon: ShieldCheck,
    tagline: "Stay aware of professional requirements.",
    items: ["License tracking", "CE", "Post-license", "Membership renewals", "Compliance reminders"],
    note: "Organizational tracking and reminders only — not legal or regulatory advice.",
  },
  {
    key: "grow", label: "GROW", icon: BarChart3,
    tagline: "Understand the business.",
    items: ["Analytics", "Goals", "Pipeline insights", "Performance visibility"],
  },
];

export const FRAGMENTS = [
  "Leads", "Follow-ups", "Transactions", "Commissions", "Tasks",
  "Marketing", "License & education deadlines", "Goals",
];

export const HOW_IT_WORKS = [
  { n: 1, title: "Set Up Your Business", body: "Create your AgentHQ workspace and personalize your business profile." },
  { n: 2, title: "Bring Your Business Together", body: "Add your relationships, follow-ups, transactions, goals, marketing, and professional requirements." },
  { n: 3, title: "Run Your Business from AgentHQ", body: "Use the Dashboard, workflows, and RESA intelligence to stay focused on what needs attention." },
];

export const RESA_CAPABILITIES = [
  "Understands your authorized AgentHQ business context",
  "Identifies items that need your attention",
  "Helps interpret your business information",
  "Assists with content and drafting where implemented",
  "Prepares next actions for you to approve",
];

export const FAQS = [
  { q: "What is AgentHQ?", a: "AgentHQ is the business operating system for real estate professionals — it brings the operational side of your business (relationships, follow-ups, transactions, commissions, tasks, marketing, compliance, and goals) into one connected workspace." },
  { q: "Is Residennce a CRM?", a: "Residennce includes a CRM, but it's more than that. A CRM knows your leads; AgentHQ helps you run your whole business — pipeline, transactions, commissions, marketing, compliance, goals, and more." },
  { q: "What is RESA?", a: "RESA — Real Estate Strategic Assistant — is the intelligence built into AgentHQ. It understands your authorized business context, surfaces what needs attention, helps interpret information, and prepares next actions for you to approve. It never acts on its own." },
  { q: "Who is AgentHQ built for?", a: "Individual real estate agents who want the operational side of their business organized in one place." },
  { q: "Is there a free trial?", a: "Yes — a 14-day free trial. A payment method is required to start, and billing begins after the trial unless you cancel." },
  { q: "What happens after the trial?", a: "Your subscription begins at $39/month (or $390/year) unless you cancel before the trial ends. There is no freemium tier." },
  { q: "What is a Founding Agent?", a: "The first 100 qualifying paid subscribers can join at a locked $19/month rate. The rate stays locked while your qualifying subscription remains continuously active. If you cancel and let it expire, the Founding rate is forfeited." },
  { q: "Can I cancel?", a: "Yes. You can cancel anytime; access continues until the end of your current billing period." },
  { q: "Does Residennce replace my MLS?", a: "No. Residennce is not an MLS and does not provide property search or listings discovery. It organizes the business side of your work." },
  { q: "Does Residennce provide legal or compliance advice?", a: "No. Compliance features provide organizational tracking and reminders only — they are not legal or regulatory advice." },
];

export const PLATFORM_FLOW = ["Contact", "Lead", "Follow-Up", "Pipeline", "Transaction", "Commission", "Past Client"];
